// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SearchResults":"ia_a bag_a bag_j bag_q bag_pt bag_pu bag_w"};